export const CHECK_TYPES = {
  CONFIRMATION: "t",
  SENTINEL: "s",
  FATIGUE: "fatigueStatus",
  MACRAIL: "h_Macrail",
  OTHER: "h_Other",
  PAID: "paid",
  UNCONFIRMATION: "unt",
  UNSENTINEL: "uns",
  UNFATIGUE: "unfatigueStatus",
  UNMACRAIL: "unh_Color",
  UNPAID: "unpaid",
};
